import apiClient from './apiClient';
import {
  ProfileResponse,
  MedicalRecordSummary,
  MedicalRecordDetail,
  PrescriptionSummary,
  MedicalRecordCreateRequest,
  BasicProfileUpdatePayload,
} from '../types';

export async function fetchProfile(): Promise<ProfileResponse> {
  const response = await apiClient.get<ProfileResponse>('/profile/me');
  return response.data;
}

export async function fetchMedicalRecords(params?: { limit?: number; offset?: number }): Promise<MedicalRecordSummary[]> {
  const response = await apiClient.get<MedicalRecordSummary[]>('/profile/medical-records', {
    params,
  });
  return response.data;
}

export async function fetchMedicalRecordDetail(recordId: number): Promise<MedicalRecordDetail> {
  const response = await apiClient.get<MedicalRecordDetail>(`/profile/medical-records/${recordId}`);
  return response.data;
}

export async function createMedicalRecord(payload: MedicalRecordCreateRequest): Promise<MedicalRecordDetail> {
  const response = await apiClient.post<MedicalRecordDetail>('/profile/medical-records', payload);
  return response.data;
}

export async function deleteMedicalRecord(recordId: number): Promise<void> {
  await apiClient.delete(`/profile/medical-records/${recordId}`);
}

export async function fetchPrescriptions(params?: { limit?: number; offset?: number; medical_record_id?: number }): Promise<PrescriptionSummary[]> {
  const response = await apiClient.get<PrescriptionSummary[]>('/profile/prescriptions', {
    params,
  });
  return response.data;
}

export async function updateBasicProfile(userId: number, payload: BasicProfileUpdatePayload) {
  const response = await apiClient.put(`/user/${userId}`, payload);
  return response.data;
}
